export namespace UserEditStateActions {
    export class GetCurrentUser {
        public static readonly type = "[UserEdit] GetCurrentUser";
    }

    export class Save {
        public static readonly type = "[UserEdit] Save";
    }
}
